exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".new-product-page-wrapper {\n  display: flex;\n  justify-content: center;\n  margin-top: 70px;\n  margin-left: 30px; }\n  .new-product-page-wrapper .page-title {\n    font-size: 18px; }\n  .new-product-page-wrapper .product-upload-card {\n    display: flex;\n    justify-content: center;\n    height: 200px;\n    width: 200px;\n    margin-bottom: 30px; }\n  .new-product-page-wrapper .description-text-area {\n    height: 125px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/stylesheets/new_products.sass
// module id = 1467
// module chunks = 0